import { AnyObj } from '../../../../../typescript';
import { defineEndpoints } from '../../../../config/define-endpoints';
import { PaginatedRequestV2, PaginatedResponseV2 } from '../../../../config/research/v2';
import type { WithUriOverride } from '../../../../config/type-helpers';
import { StudioExecutionState } from '../models';

import type { ExecutionMetadata } from './execution-api';

type ExecutionShapeV2<T extends string = string> = {
    id: number;
    user_id: number;
    query_id: number;
    execution_id: string;
    state: StudioExecutionState;
    metadata: ExecutionMetadata<T>;
    error: string;
    execution_ended_at: number;
    execution_started_at: number;
    expires_at: number;
    is_execution_finished_cache: boolean;
    created_at: number;
    updated_at: number;
};

type GetExecutionRequestV2 = PaginatedRequestV2<
    AnyObj,
    WithUriOverride<{
        id: string;
        filter?: string;
    }>
>;

type GetExecutionResponseV2 = PaginatedResponseV2<
    AnyObj,
    {
        execution: ExecutionShapeV2;
    }
>;

type PostExecuteQueryRequestV2 = {
    query_id: number;
};

type PostExecuteQueryResponseV2 = {
    id: number;
    user_id: number;
    query_id: number;
    execution_id: string;
    state: StudioExecutionState;
    metadata: ExecutionMetadata<string>;
    error: string;
    execution_ended_at: number;
    execution_started_at: number;
    expires_at: number;
    is_execution_finished_cache: boolean;
    created_at: number;
    updated_at: number;
};

const STUDIO_EXECUTION_V2_ENDPOINTS = defineEndpoints(template => ({
    GET: {
        EXECUTION_ROWS: template('/v3/studio/queries/executions/{id}/rows'),
    },
    POST: {
        EXECUTE_QUERY: template('/v3/studio/queries/executions'),
    },
}));

export type {
    ExecutionShapeV2,
    GetExecutionRequestV2,
    GetExecutionResponseV2,
    PostExecuteQueryRequestV2,
    PostExecuteQueryResponseV2,
};
export { STUDIO_EXECUTION_V2_ENDPOINTS };
